module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Iniciacion.6ae54927.png";